export var FaqType;
(function (FaqType) {
    FaqType["Setup"] = "Setup";
    FaqType["Pairing"] = "Pairing";
})(FaqType || (FaqType = {}));
